<div
    id="page-loader"
    *ngIf="visible"
    [class.fade-out]="fading"
    role="status"
    aria-label="Loading">

    <div class="loader-content">

        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/images/new-theme/logo.webp"
            alt="GH Raisoni College of Engineering and Management"
            class="loader-logo">

        <div
            class="loader-dots"
            aria-hidden="true">

            <span></span>
            <span></span>
            <span></span>

        </div>

    </div>

</div>
